<template>
    <b-card class="rounded-0 mb-n3">
        <b-button @click="$refs.modal.show()" 
            class="mb-1" 
            id="btn-loeschen" 
            variant="danger" block
        >
            Account löschen
        </b-button>
        <b-modal ref="modal" id="loescheModal" 
            title="Account wirklich löschen?"
            cancelTitle="Abbrechen"
            :ok-disabled="loading"
            :cancel-disabled="loading"
            @ok="loescheUserHandler"
            :header-bg-variant="darkmode ? 'dark' : ''"
            :header-text-variant="darkmode ? 'light' : ''"
            :body-bg-variant="darkmode ? 'dark' : ''" 
            :body-text-variant="darkmode ? 'light' : ''"
            :footer-bg-variant="darkmode ? 'dark' : ''"
            :footer-text-variant="darkmode ? 'light' : ''"
        >
            <template v-slot:modal-ok>
                Ja <b-spinner v-if='loading' small />
            </template>

            <b-form-group label-cols-sm="4" label-cols-lg="4" label="Benutzername" label-for="loeschen-Benutzername">
                <b-input-group>
                    <b-form-input :class="darkmode ? 'bg-dark text-light border-secondary' : ''" type="text" id="loeschen-Benutzername" v-model="username"></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label-cols-sm="4" label-cols-lg="4" label="Passwort" label-for="loeschen-Passwort">
                <b-input-group>
                    <b-form-input type="password" :class="darkmode ? 'bg-dark text-light border-secondary' : ''" id="loeschen-Passwort" v-model="password"></b-form-input>
                </b-input-group>
            </b-form-group>
        </b-modal>
    </b-card>
</template>

<script>
import { setAlert } from '../tools'
import { loescheUser } from '../store/apiHelper'
import { BCard, BInputGroup, BFormInput, BSpinner } from "bootstrap-vue"
import { mapGetters } from 'vuex'
export default {
    name: "EinstellungenLoeschenCard",
    components:{
        BCard,
        BInputGroup, 
        BFormInput,
        BSpinner
    },
    computed: mapGetters(['darkmode']),
    data(){
        return{
            loading: false,
            username: '',
            password: ''
        }
    },
    methods:{
        async loescheUserHandler()
        {
            this.loading = true
            try {
                await loescheUser({ username: this.username, password: this.password })
                this.$router.push("/login")
            }
            catch (err) {
                setAlert(this, err.response.data, 'Löschen fehlgeschlagen', 'danger')
            }
            this.loading = false
        },
    }
}
</script>